/**
 * Represents which Workspace links a User has access to visit.
 */
import { NavLink } from '@client/components/navigation/types';
import { defineTransform } from '@client/core/data/concerns/parses-from-json/transform-map';
import { JsonResponse } from '@client/core/data/concerns/parses-from-json/types';

/**
 * Must be kept in sync with backend class WorkspaceNavigation.
 *
 * @see app/View/WorkspaceNavigation.php
 */
export class WorkspaceNavigation {
  constructor(
    public readonly addProjects: boolean,
    public readonly siteSearch: boolean,
    public readonly contactsVendors: boolean,
    public readonly calendar: boolean,
    public readonly materialCatalog: boolean,
    public readonly workspaceTasks: boolean,
    public readonly activityLog: boolean,
    public readonly notifications: boolean,
    public readonly byStage: NavLink[],
    public readonly byFeature: NavLink[],
    public readonly teamPulse: NavLink[],
    public readonly companySettings: NavLink[],
    public readonly templateSettings: NavLink[],
    public readonly accountSettings: NavLink[],
    public readonly siteAdminSettings: NavLink[],
  ) {}
}

/**
 * @param item {Record<string, any>} An array of links from WorkspaceNavigation.php
 */
function makeNavLink(item: Record<string, any>): NavLink {
  return {
    href: item.url,
    text: item.text,
    extraCssClasses: item.extraCssClasses || [],
  };
}

defineTransform(WorkspaceNavigation, (json: JsonResponse) => {
  return {
    ...json,
    byStage: json.byStage.map((item) => makeNavLink(item)),
    byFeature: json.byFeature.map((item) => makeNavLink(item)),
    teamPulse: json.teamPulse.map((item) => makeNavLink(item)),
    companySettings: json.companySettings.map((item) => makeNavLink(item)),
    templateSettings: json.templateSettings.map((item) => makeNavLink(item)),
    accountSettings: json.accountSettings.map((item) => makeNavLink(item)),
    siteAdminSettings: json.siteAdminSettings.map((item) => makeNavLink(item)),
  };
});
